import { allCapsShadowCss } from './allCapsShadowCss.js'

const template = document.createElement('template')
template.innerHTML = `${allCapsShadowCss}
<link href="https://fonts.googleapis.com/css2?family=Bonbon&family=Butcherman&family=Fontdiner+Swanky&family=Fredericka+the+Great&family=Londrina+Outline&family=Love+Ya+Like+A+Sister&family=Moo+Lah+Lah&family=Mountains+of+Christmas&family=Noto+Color+Emoji&family=Noto+Music&family=Noto+Sans+Symbols+2&family=Oi&family=Ole&family=Rubik+Burned&family=Unkempt&display=swap" rel="stylesheet">
<style>
button, select, option {
  text-transform: inherit;
}
  :host {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    max-width: 800px;
    width: 90%;
    background: #e0e0e0;
    padding: 30px 8px 8px 8px; /* Increased top padding for close button */
    box-sizing: border-box;
    display: none;
    z-index: 5000;
    box-shadow: 0 -2px 10px rgba(0,0,0,0.3);
    user-select: none;
    border-radius: 8px 8px 0 0;
  }
  :host([visible]) {
    display: block;
  }
  .keyboard-row {
    display: flex;
    justify-content: center;
    margin-bottom: 3px;
  }
  .scroll-container {
    max-height: 250px;
    overflow-y: auto;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));
    gap: 4px;
    padding: 4px;
    background: #f0f0f0;
    border-radius: 4px;
  }
  .key {
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 3px;
    margin: 1px;
    padding: 6px 4px;
    min-width: 28px;
    height: 32px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    flex: 1;
    color: #333;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
    position: relative;
  }
  .key.symbol {
    height: 48px;
    font-size: 28px;
    margin: 0;
  }
  .key-label {
    font-family: sans-serif;
    font-size: 10px;
    color: #666;
    position: absolute;
    top: 2px;
    left: 2px;
  }
  .key-preview {
    font-size: 16px;
  }
  .key:active {
    background: #ddd;
    box-shadow: inset 0 1px 2px rgba(0,0,0,0.1);
  }
  .key.wide {
    flex: 1.5;
    font-family: sans-serif;
  }
  .key.space {
    flex: 5;
    font-family: sans-serif;
  }
  .close-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    background: #ff6b6b;
    border: none;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    font-weight: bold;
    font-size: 18px;
    color: white;
    line-height: 20px;
    padding: 0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.3);
    z-index: 10;
  }
  .close-btn:hover {
    background: #ff5252;
  }
  /* Scrollbar styling */
  .scroll-container::-webkit-scrollbar {
    width: 8px;
  }
  .scroll-container::-webkit-scrollbar-track {
    background: #f1f1f1; 
  }
  .scroll-container::-webkit-scrollbar-thumb {
    background: #888; 
    border-radius: 4px;
  }
  .scroll-container::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
</style>
<button class="close-btn" id="close">×</button>
<div id="keys"></div>
`

class SeKeyboard extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
    this.shadowRoot.appendChild(template.content.cloneNode(true))
    this.$keys = this.shadowRoot.getElementById('keys')
    this.shift = false
    this.caps = false

    // Force hidden on init with inline style as fallback
    this.style.display = 'none'

    this.layouts = {
      default: [
        ['\\', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', "'", 'ì'],
        ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'è', '+'],
        ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'ò', 'à', 'ù'],
        ['<', 'z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '-']
      ],
      shift: [
        ['|', '!', '"', '£', '$', '%', '&', '/', '(', ')', '=', '?', '^'],
        ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', 'é', '*'],
        ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'ç', '°', '§'],
        ['>', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', ';', ':', '_']
      ],
      // Flattened arrays for scrollable layouts
      'Noto Music': '♩♪♫♬♭♮♯𝄞𝄢𝄡𝄇𝄈𝄐𝄑𝄒𝄓𝄔𝄕𝄖𝄗𝄘𝄙𝄚𝄛𝄜𝄝𝄟𝄠𝄣𝄤𝄥𝄦𝄧𝄨𝄩𝄪𝄫𝄬𝄭𝄮𝄯𝆑𝆒𝆓𝆔𝆕𝆖𝆗𝆘𝆙𝆚𝆛𝆜𝆝𝆞𝆟𝆠𝆡𝆢𝆣𝆤𝆥𝆦𝆧𝆨𝆩𝆪𝆫𝆬𝆭𝆮𝆯𝆰𝆱𝆲𝆳𝆴𝆵𝆶𝆷𝆸𝆹𝆺𝆹𝅥𝆺𝅥𝆹𝅥𝅮𝆺𝅥𝅮𝆹𝅥𝅯'.split(''),
      'Noto Color Emoji': '😀😃😄😁😆😅😂🤣🥲☺️😊😇🙂🙃😉😌😍🥰😘😗😙😚😋😛😝😜🤪🤨🧐🤓😎🥸🤩🥳😏😒😞😔😟😕🙁☹️😣😖😫😩🥺😢😭😤😠😡🤬🤯😳🥵🥶😱😨😰😥😓🤗🤔🤭🤫🤥😶😐😑😬🙄😯😦😧😮😲🥱😴🤤😪😵🤐🥴🤢🤮🤧😷🤒🤕'.match(/./gu) || [],
      'Noto Sans Symbols 2': '★ ☆ ☎ ☏ ☛ ☚ ☞ ☜ ☺ ☻ ☹ ☼ ☽ ☾ ☿ ♀ ♁ ♂ ♃ ♄ ♅ ♆ ♇ ♔ ♕ ♖ ♗ ♘ ♙ ♚ ♛ ♜ ♝ ♞ ♟ ♠ ♡ ♢ ♣ ♤ ♥ ♦ ♧ ♨ ♩ ♪ ♫ ♬ ♭ ♮ ♯ ♰ ♱ ♲ ♳ ♴ ♵ ♶ ♷ ♸ ♹ ♺ ♻ ♼ ♽ ♾ ♿ ⚒ ⚓ ⚔ ⚕ ⚖ ⚗ ⚘ ⚙ ⚚ ⚛ ⚜ ⚠ ⚡ ⚢ ⚣ ⚤ ⚥ ⚦ ⚧ ⚨ ⚩ ⚪ ⚫ ⚬ ⚭ ⚮ ⚯ ⚰ ⚱ ⚲ ⚳ ⚴ ⚵ ⚶ ⚷ ⚸ ⚹ ⚺ ⚻ ⚼ ⚽ ⚾ ⚿ ⛀ ⛁ ⛂ ⛃ ⛄ ⛅ ⛆ ⛇ ⛈ ⛉ ⛊ ⛋ ⛌ ⛍ ⛎ ⛏ ⛐ ⛑ ⛒ ⛓ ⛔ ⛕ ⛖ ⛗ ⛘ ⛙ ⛚ ⛛ ⛜ ⛝ ⛞ ⛟ ⛠ ⛡ ⛢ ⛣ ⛤ ⛥ ⛦ ⛧ ⛨ ⛩ ⛪ ⛫ ⛬ ⛭ ⛮ ⛯ ⛰ ⛱ ⛲ ⛳ ⛴ ⛵ ⛶ ⛸ ⛹ ⛺ ⛻ ⛼ ⛽ ⛾ ⛿'.split(' ')
    }

    this.initKeys()

    // Use addEventListener for more reliable event handling in shadow DOM
    const closeBtn = this.shadowRoot.getElementById('close')
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.hide()
    })
  }

  show() {
    this.style.display = 'block'
    this.setAttribute('visible', '')
  }

  hide() {
    this.style.display = 'none'
    this.removeAttribute('visible')
  }

  initKeys() {
    this.render()
  }

  render() {
    this.$keys.innerHTML = ''
    const currentFont = this.getAttribute('font-family') || 'sans-serif'

    // Check for special scrollable layouts
    if (this.layouts[currentFont]) {
      const symbols = this.layouts[currentFont]
      const scrollContainer = document.createElement('div')
      scrollContainer.className = 'scroll-container'

      symbols.forEach(char => {
        if (!char || char === '') return
        const key = document.createElement('div')
        key.className = 'key symbol'
        key.textContent = char
        key.style.fontFamily = currentFont
        key.onclick = () => this.onKeyPress(char)
        scrollContainer.appendChild(key)
      })

      this.$keys.appendChild(scrollContainer)

      // Add Backspace in a separate row at the bottom for convenience
      const controlsRow = document.createElement('div')
      controlsRow.className = 'keyboard-row'
      controlsRow.style.marginTop = '5px'

      const backspace = document.createElement('div')
      backspace.className = 'key wide'
      backspace.textContent = '⌫ Backspace'
      backspace.style.fontFamily = 'sans-serif'
      backspace.onclick = () => this.onKeyPress('Backspace')
      controlsRow.appendChild(backspace)

      const space = document.createElement('div')
      space.className = 'key wide'
      space.textContent = 'Space'
      space.style.fontFamily = 'sans-serif'
      space.onclick = () => this.onKeyPress(' ')
      controlsRow.appendChild(space)

      this.$keys.appendChild(controlsRow)

    } else {
      // Standard QWERTY Layout
      const layout = this.shift ? this.layouts.shift : this.layouts.default

      layout.forEach((row, rowIndex) => {
        const rowDiv = document.createElement('div')
        rowDiv.className = 'keyboard-row'

        if (rowIndex === 2) {
          const capsKey = document.createElement('div')
          capsKey.className = 'key wide'
          capsKey.textContent = 'Caps'
          capsKey.onclick = () => this.toggleCaps()
          if (this.caps) capsKey.style.background = '#ccc'
          rowDiv.appendChild(capsKey)
        }
        if (rowIndex === 3) {
          const shiftKey = document.createElement('div')
          shiftKey.className = 'key wide'
          shiftKey.textContent = 'Shift'
          shiftKey.onclick = () => this.toggleShift()
          if (this.shift) shiftKey.style.background = '#ccc'
          rowDiv.appendChild(shiftKey)
        }

        row.forEach(char => {
          const key = document.createElement('div')
          key.className = 'key'

          const label = document.createElement('span')
          label.className = 'key-label'
          label.textContent = char
          key.appendChild(label)

          const preview = document.createElement('span')
          preview.className = 'key-preview'
          preview.style.fontFamily = currentFont
          preview.textContent = char
          key.appendChild(preview)

          key.onclick = () => this.onKeyPress(char)
          rowDiv.appendChild(key)
        })

        if (rowIndex === 0) {
          const backspace = document.createElement('div')
          backspace.className = 'key wide'
          backspace.textContent = '⌫'
          backspace.style.fontFamily = 'sans-serif'
          backspace.onclick = () => this.onKeyPress('Backspace')
          rowDiv.appendChild(backspace)
        }
        if (rowIndex === 3) {
          const shiftKeyR = document.createElement('div')
          shiftKeyR.className = 'key wide'
          shiftKeyR.textContent = 'Shift'
          shiftKeyR.onclick = () => this.toggleShift()
          if (this.shift) shiftKeyR.style.background = '#ccc'
          rowDiv.appendChild(shiftKeyR)
        }

        this.$keys.appendChild(rowDiv)
      })

      const spaceRow = document.createElement('div')
      spaceRow.className = 'keyboard-row'
      const space = document.createElement('div')
      space.className = 'key space'
      space.textContent = 'Space'
      space.style.fontFamily = 'sans-serif'
      space.onclick = () => this.onKeyPress(' ')
      spaceRow.appendChild(space)
      this.$keys.appendChild(spaceRow)
    }
  }

  toggleShift() {
    this.shift = !this.shift
    this.render()
  }

  toggleCaps() {
    this.caps = !this.caps
    this.shift = this.caps
    this.render()
  }

  onKeyPress(key) {
    this.dispatchEvent(new CustomEvent('change', { detail: { value: key } }))
    if (this.shift && !this.caps) {
      this.shift = false
      this.render()
    }
  }

  setFont(fontFamily) {
    this.setAttribute('font-family', fontFamily)
    this.render() // Attribute change callback will handle this, but for safety
  }

  static get observedAttributes() {
    return ['font-family']
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'font-family' && oldValue !== newValue) {
      this.render()
    }
  }
}

customElements.define('se-keyboard', SeKeyboard)
